<template>
  <fb-form-properties-manager id="treatment-plan-objectives-v1-properties-onf8g2" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "TreatmentPlanObjectivesV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
